import { LockOpenAlertIcon } from './LockOpenAlertIcon';

/**
 * author: François Risoud
 * id D8707612-8DFB-4F83-9FAE-2058254A651F
 * name lock-open-alert
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-alert.svg
 * tags
 * - Alert / Error 
 * - Home Automation 
 * - Lock 
 */
export const DecryptedAlertIcon = LockOpenAlertIcon;
export default DecryptedAlertIcon